var map = {
	"./default.png": "./admin-thumbs/default.png",
	"./s-cards.png": "./admin-thumbs/s-cards.png",
	"./s-carousel-card.png": "./admin-thumbs/s-carousel-card.png",
	"./s-carousel-cards.png": "./admin-thumbs/s-carousel-cards.png",
	"./s-divider.png": "./admin-thumbs/s-divider.png",
	"./s-editor-media.png": "./admin-thumbs/s-editor-media.png",
	"./s-editor.png": "./admin-thumbs/s-editor.png",
	"./s-form.png": "./admin-thumbs/s-form.png",
	"./s-gallery.png": "./admin-thumbs/s-gallery.png",
	"./s-header-image.png": "./admin-thumbs/s-header-image.png",
	"./s-header.png": "./admin-thumbs/s-header.png",
	"./s-hero.png": "./admin-thumbs/s-hero.png",
	"./s-logos.png": "./admin-thumbs/s-logos.png",
	"./s-names.png": "./admin-thumbs/s-names.png",
	"./s-text-logo.png": "./admin-thumbs/s-text-logo.png",
	"./s-usps.png": "./admin-thumbs/s-usps.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./admin-thumbs sync recursive \\.png$";